<template>
  <div class="website-section content-wrapper" v-if="isLoaded">
    <app-header></app-header>
    <content-row v-for="(row,index) in sectionContent" :content="content" :index="index" :row="row"
                 :key="row.id"></content-row>
    <content-row v-for="(row,index) in content" :content="content" :index="index" :row="row"
                 :key="row.id"></content-row>
  </div>
</template>
<script>
  import appHeader from '../layout/Header.vue'
  import ContentRow from './ContentRow.vue'

  export default {
    data () {
      return {
        isLoaded: false,
        content: {},
        sectionContent: {}
      }
    },
    created () {
      this.getData(this.$route.params.slug2)
    },
    components: {
      ContentRow,
      appHeader
    },
    methods: {
      getData (slug2) {
        this.isLoaded = false
        this.axios.get('/sections/view-sub?slug=' + slug2)
          .then(response => {
            this.content = response.data.subSection.content
            this.sectionContent = response.data.subSection.section.content
            document.title = response.data.subSection.title ? response.data.subSection.title + ' - ' + this.$store.getters.settings.appName : this.$store.getters.settings.appName
            this.isLoaded = true
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    watch: {
      '$route' (to, from) {
        this.getData(to.params.slug2)
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/SubSection.vue